import React from "react";
import { getFontFamilyString } from "@excalidraw/common";

import type { FontFamilyValues } from "@excalidraw/element/types";

interface FontPreviewProps {
  fontFamily: FontFamilyValues;
  text: string;
  size?: number;
  className?: string;
}

export const FontPreview: React.FC<FontPreviewProps> = ({
  fontFamily,
  text,
  size = 14,
  className = "",
}) => {
  const fontFamilyString = getFontFamilyString({ fontFamily });

  return (
    <span
      className={`font-preview ${className}`}
      style={{
        fontFamily: fontFamilyString,
        fontSize: `${size}px`,
        lineHeight: 1.2,
      }}
    >
      {text}
    </span>
  );
};
